import { STORE_ADMIN_BASE, STORE_ADMIN_HOME } from 'app/shared/entitlement/store-admin-paths.util';

export type ModuleNavSection = {
    id: string;
    link?: string;
};

export type ModuleNavGroup = {
    id: string;
    children?: ModuleNavSection[];
};

function normalizePath(path: string): string {
    return path.split('?')[0].replace(/\/$/, '') || '/';
}

/** Whether a module sidebar section should appear active for the current URL. */
export function isModuleSectionActive(section: ModuleNavSection, module: ModuleNavGroup, url: string): boolean {
    const normalizedUrl = normalizePath(url);
    const link = normalizePath(section.link || '');

    if (!link) {
        return false;
    }

    const moduleRoot = module.id === 'store' ? normalizePath(STORE_ADMIN_HOME) : normalizePath(`/${module.id}`);

    if (link !== moduleRoot) {
        return normalizedUrl === link || normalizedUrl.startsWith(`${link}/`);
    }

    for (const sibling of module.children ?? []) {
        if (sibling.id === section.id || !sibling.link) {
            continue;
        }
        const siblingLink = normalizePath(sibling.link);
        if (normalizedUrl === siblingLink || normalizedUrl.startsWith(`${siblingLink}/`)) {
            return false;
        }
    }

    return normalizedUrl === moduleRoot || normalizedUrl.startsWith(`${moduleRoot}/`);
}
